'use client';

import React from 'react';
import Image from 'next/image';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay, Pagination, Navigation } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/navigation';

interface Banner {
  id: number;
  image: string;
  title?: string;
  description?: string;
}

interface BannerProps {
  banners: Banner[];
}

const Banner: React.FC<BannerProps> = ({ banners }) => {
  if (!banners || banners.length === 0) {
    return null;
  }

  return (
    <section className="banner-section">
      <div className="banner-container">
        <Swiper
          modules={[Autoplay, Pagination, Navigation]}
          spaceBetween={0}
          slidesPerView={1}
          autoplay={{
            delay: 4000,
            disableOnInteraction: false,
          }}
          pagination={{
            clickable: true,
            bulletClass: "swiper-pagination-bullet casino-bullet",
            bulletActiveClass: "swiper-pagination-bullet-active casino-bullet-active",
          }}
          navigation={true}
          loop={true}
          className="banner-swiper"
        >
          {banners.map((banner, index) => (
            <SwiperSlide key={banner.id || index}>
              <div className="banner-slide">
                <Image
                  src={banner.image}
                  alt={`Banner ${index + 1}`}
                  width={1200}
                  height={500}
                  className="banner-image"
                  priority={index === 0}
                />
                <div className="banner-overlay"></div>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </section>
  );
};

export default Banner;
